// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23605e5c%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Shared Task Pane Styles
 */

:root {
  --primary-color: #0078d4;
  --success-color: #107c10;
  --error-color: #d13438;
  --warning-color: #ffb900;
  --text-color: #323130;
  --text-secondary: #605e5c;
  --border-color: #edebe9;
  --background-color: #ffffff;
  --hover-background: #f3f2f1;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  color: var(--text-color);
  background-color: var(--background-color);
  line-height: 1.5;
}

/* Task Pane Layout */
.task-pane {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 16px;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 16px;
}

.header h1 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-color);
}

.header-actions {
  display: flex;
  gap: 8px;
}

.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: var(--text-secondary);
}

.icon-button:hover {
  background-color: var(--hover-background);
}

/* Main Content */
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Form Groups */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

.form-group.required label::after {
  content: ' *';
  color: var(--error-color);
}

/* Inputs */
input[type="text"],
input[type="password"],
input[type="email"],
input[type="number"],
select,
textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.15s ease;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 1px var(--primary-color);
}

input:disabled,
select:disabled,
textarea:disabled {
  background-color: #f3f2f1;
  cursor: not-allowed;
}

select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 32px;
}

textarea {
  min-height: 100px;
  resize: vertical;
}

/* Buttons */
.button-group {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

button, .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: var(--background-color);
  color: var(--text-color);
}

button:hover:not(:disabled), .btn:hover:not(:disabled) {
  background-color: var(--hover-background);
}

button:disabled, .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #106ebe;
  border-color: #106ebe;
}

.btn-success {
  background-color: var(--success-color);
  border-color: var(--success-color);
  color: white;
}

.btn-success:hover:not(:disabled) {
  background-color: #0b6a0b;
  border-color: #0b6a0b;
}

/* Messages */
.message {
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  display: none;
}

.message-success {
  background-color: #dff6dd;
  border: 1px solid var(--success-color);
  color: #107c10;
}

.message-success a {
  color: #107c10;
  font-weight: 600;
  text-decoration: underline;
}

.message-error {
  background-color: #fde7e9;
  border: 1px solid var(--error-color);
  color: #a80000;
}

.message-info {
  background-color: #f0f6ff;
  border: 1px solid var(--primary-color);
  color: #004578;
}

.message-warning {
  background-color: #fff4ce;
  border: 1px solid var(--warning-color);
  color: #735c0f;
}

/* Loading Spinner */
.loading {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  color: var(--text-secondary);
}

.loading.show {
  display: flex;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Footer */
.footer {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
  text-align: center;
  font-size: 11px;
  color: var(--text-secondary);
}

.footer a {
  color: var(--primary-color);
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}

/* Data Table */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.data-table th,
.data-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.data-table th {
  font-weight: 600;
  background-color: #f3f2f1;
  color: var(--text-secondary);
}

.data-table tr:hover {
  background-color: var(--hover-background);
}

.data-table tr.selected {
  background-color: #e6f2ff;
}

/* Radio in table */
.data-table input[type="radio"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* Sender info */
.sender-info {
  background-color: #f3f2f1;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  color: var(--text-secondary);
}

.sender-info strong {
  color: var(--text-color);
}

/* TinyMCE container */
.editor-container {
  min-height: 200px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
}

/* Responsive */
@media (max-width: 400px) {
  .task-pane {
    padding: 12px;
  }

  .button-group {
    flex-direction: column;
  }

  button, .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sEAAsE;EACtE,eAAe;EACf,wBAAwB;EACxB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;;;;;EAME,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\r\n * Shared Task Pane Styles\r\n */\r\n\r\n:root {\r\n  --primary-color: #0078d4;\r\n  --success-color: #107c10;\r\n  --error-color: #d13438;\r\n  --warning-color: #ffb900;\r\n  --text-color: #323130;\r\n  --text-secondary: #605e5c;\r\n  --border-color: #edebe9;\r\n  --background-color: #ffffff;\r\n  --hover-background: #f3f2f1;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  font-size: 14px;\r\n  color: var(--text-color);\r\n  background-color: var(--background-color);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Task Pane Layout */\r\n.task-pane {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  padding: 16px;\r\n}\r\n\r\n/* Header */\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.header h1 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--text-color);\r\n}\r\n\r\n.header-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.icon-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  border-radius: 4px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.icon-button:hover {\r\n  background-color: var(--hover-background);\r\n}\r\n\r\n/* Main Content */\r\n.content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n/* Form Groups */\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.form-group label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.form-group.required label::after {\r\n  content: ' *';\r\n  color: var(--error-color);\r\n}\r\n\r\n/* Inputs */\r\ninput[type=\"text\"],\r\ninput[type=\"password\"],\r\ninput[type=\"email\"],\r\ninput[type=\"number\"],\r\nselect,\r\ntextarea {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  transition: border-color 0.15s ease;\r\n}\r\n\r\ninput:focus,\r\nselect:focus,\r\ntextarea:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 1px var(--primary-color);\r\n}\r\n\r\ninput:disabled,\r\nselect:disabled,\r\ntextarea:disabled {\r\n  background-color: #f3f2f1;\r\n  cursor: not-allowed;\r\n}\r\n\r\nselect {\r\n  appearance: none;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23605e5c' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 12px center;\r\n  padding-right: 32px;\r\n}\r\n\r\ntextarea {\r\n  min-height: 100px;\r\n  resize: vertical;\r\n}\r\n\r\n/* Buttons */\r\n.button-group {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n  margin-top: 16px;\r\n}\r\n\r\nbutton, .btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n}\r\n\r\nbutton:hover:not(:disabled), .btn:hover:not(:disabled) {\r\n  background-color: var(--hover-background);\r\n}\r\n\r\nbutton:disabled, .btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: var(--primary-color);\r\n  border-color: var(--primary-color);\r\n  color: white;\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  background-color: #106ebe;\r\n  border-color: #106ebe;\r\n}\r\n\r\n.btn-success {\r\n  background-color: var(--success-color);\r\n  border-color: var(--success-color);\r\n  color: white;\r\n}\r\n\r\n.btn-success:hover:not(:disabled) {\r\n  background-color: #0b6a0b;\r\n  border-color: #0b6a0b;\r\n}\r\n\r\n/* Messages */\r\n.message {\r\n  padding: 12px;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  display: none;\r\n}\r\n\r\n.message-success {\r\n  background-color: #dff6dd;\r\n  border: 1px solid var(--success-color);\r\n  color: #107c10;\r\n}\r\n\r\n.message-success a {\r\n  color: #107c10;\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n}\r\n\r\n.message-error {\r\n  background-color: #fde7e9;\r\n  border: 1px solid var(--error-color);\r\n  color: #a80000;\r\n}\r\n\r\n.message-info {\r\n  background-color: #f0f6ff;\r\n  border: 1px solid var(--primary-color);\r\n  color: #004578;\r\n}\r\n\r\n.message-warning {\r\n  background-color: #fff4ce;\r\n  border: 1px solid var(--warning-color);\r\n  color: #735c0f;\r\n}\r\n\r\n/* Loading Spinner */\r\n.loading {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 16px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.loading.show {\r\n  display: flex;\r\n}\r\n\r\n.spinner {\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 2px solid var(--border-color);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Footer */\r\n.footer {\r\n  margin-top: auto;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border-color);\r\n  text-align: center;\r\n  font-size: 11px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.footer a {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.footer a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Data Table */\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 13px;\r\n}\r\n\r\n.data-table th,\r\n.data-table td {\r\n  padding: 8px;\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.data-table th {\r\n  font-weight: 600;\r\n  background-color: #f3f2f1;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.data-table tr:hover {\r\n  background-color: var(--hover-background);\r\n}\r\n\r\n.data-table tr.selected {\r\n  background-color: #e6f2ff;\r\n}\r\n\r\n/* Radio in table */\r\n.data-table input[type=\"radio\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Sender info */\r\n.sender-info {\r\n  background-color: #f3f2f1;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sender-info strong {\r\n  color: var(--text-color);\r\n}\r\n\r\n/* TinyMCE container */\r\n.editor-container {\r\n  min-height: 200px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 400px) {\r\n  .task-pane {\r\n    padding: 12px;\r\n  }\r\n\r\n  .button-group {\r\n    flex-direction: column;\r\n  }\r\n\r\n  button, .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
